import api from 'aio-api'
import Vue from 'vue'

function initPushNotifications () {
  const push = window.PushNotification.init({
    android: {
      icon: 'myicon',
      iconColor: '#E51358',
      clearBadge: true,
    },
    ios: {
      alert: true,
      badge: true,
      sound: true,
      clearBadge: true,
    },
    windows: {},
  })
  push.on('registration', function (data) {
    localStorage.setItem('device_token', data.registrationId)
  })
  push.on('notification', function (data) {
    Vue.bus.$emit('push-notification', data)
  })
  push.on('error', function (e) {
    console.error(e.message)
  })
}

export default {
  loadCordova (cb) {
    if (!window.cordova) {
      cb()
    } else {
      document.addEventListener('deviceready', () => {
        initPushNotifications()
        document.addEventListener('resume', () => {
          Vue.bus.$emit('resume-app')
        })
        cb()
      })
    }
  },
  computed: {
    isAndroid () {
      return this.isDevice && window.device.platform === 'Android'
    },
    isAndroidSdkGreater23 () {
      return this.isAndroid && parseInt(window.device.version.match(/\d+/g)[0]) >= 6
    },
    isIOS () {
      return this.isDevice && window.device.platform === 'iOS'
    },
    isDevice () {
      return typeof window.device !== 'undefined'
    },
    hasCamera () {
      return navigator.camera
    },
    hrefTarget () {
      return this.isDevice ? '_system' : '_blank'
    },
  },
  data () {
    return {
      hasAndroidFingerprint: false,
      hasFaceID: false,
      hasTouchID: false,
    }
  },
  methods: {
    async checkDevice (onIsKnown) {
      if (localStorage.device_token) {
        let result
        try {
          result = await api.getDevice(localStorage.device_token)
        } catch (err) {
          // There was an error checking the token, keep it since this could just be a network error
          // this.$f7.dialog.alert('Error checking biometric token, please check your internet connection', '')
          console.error(err)
          return
        }

        if (result.hasUser) {
          onIsKnown()
        } else {
          // Token isn't valid, clear it so we register a new one
          delete localStorage.device_token
        }
      }
    },
    initBiometricAuth () {
      if (this.isIOS) {
        this.initBiometricsForIOS()
      } else if (this.isAndroidSdkGreater23) {
        this.initBiometricsForAndroid()
      }
    },
    initBiometricsForAndroid () {
      const self = this
      this.checkDevice(() => {
        function verify () {
          window.FingerprintAuth.encrypt({
            clientId: 'com.levima.app',
            clientSecret: 'slept-happiness-guidable-mundane-cobalt',
          }, self.loginDevice)
        }

        window.FingerprintAuth.isAvailable(result => {
          if (result.isAvailable) {
            if (typeof localStorage.allow_biometric_auth === 'undefined') {
              self.$f7.dialog.confirm('Do you want to use Fingerprint Authentication?', '', () => {
                localStorage.setItem('allow_biometric_auth', true)
                verify()
              }, () => {
                localStorage.setItem('allow_biometric_auth', false)
              })
            } else if (localStorage.allow_biometric_auth === 'true') {
              verify()
            }
          }
        })
      })
    },
    initBiometricsForIOS () {
      const self = this
      this.checkDevice(() => {
        function verify () {
          const msg = localStorage.allow_biometric_auth === 'face' ? 'Please unlock with your face' : 'Please scan your fingerprint'
          window.plugins.touchid.verifyFingerprint(msg, () => {
            window.plugins.touchid.didFingerprintDatabaseChange(changed => {
              if (changed) {
                self.$f7.dialog.alert('For additional security, please log in with email and password this time.', '')
              } else {
                self.loginDevice()
              }
            })
          })
        }

        window.plugins.touchid.isAvailable(authType => {
          if (typeof localStorage.allow_biometric_auth === 'undefined') {
            const service = authType.charAt(0).toUpperCase() + authType.slice(1) + 'ID'
            self.$f7.dialog.confirm(`Do you want to use ${service} to authenticate?`, '', () => {
              localStorage.setItem('allow_biometric_auth', authType)
              verify()
            }, () => {
              localStorage.setItem('allow_biometric_auth', false)
            })
          } else if (localStorage.allow_biometric_auth !== 'false') {
            verify()
          }
        })
      })
    },
    loginDevice () {
      this.$bus.$emit('deviceLogin', localStorage.device_token )
    },
    async registerDevice () {
      // Generate a device token if one doesn't exist (PK of device db-table)
      if (typeof localStorage.device_token === 'undefined') {
        const bytes = new Uint8Array(32)
        crypto.getRandomValues(bytes)
        localStorage.device_token = btoa(String.fromCharCode.apply(null, bytes))
      }
      const device = this.isDevice ? window.device : {
        model: navigator.userAgent,
        platform: 'Browser',
        version: navigator.appVersion,
        isVirtual: false,
      }
      device.token = localStorage.device_token
      let reg = await api.device.register(device)
    },
  },
  mounted () {
    if (window.FingerprintAuth) {
      window.FingerprintAuth.isAvailable(d => this.hasAndroidFingerprint = d.isAvailable)
    }
    if (window.plugins && window.plugins.touchid) {
      window.plugins.touchid.isAvailable(authType => {
        this.hasFaceID = authType === 'face'
        this.hasTouchID = authType === 'touch'
      })
    }
  },
}
